import { render } from "./EditFiliereNiveauMatierePage.vue?vue&type=template&id=ee1928d2&ts=true"
import script from "./EditFiliereNiveauMatierePage.vue?vue&type=script&lang=ts"
export * from "./EditFiliereNiveauMatierePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__